import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zkf5unaq8w: FaireBrandEntity = {
  token: "b_zkf5unaq8w",
  type: "brand",
  name: "hey champ",
  avatarUrl:
    "https://cdn.faire.com/fastly/f41a6358e8640f278fdac3a5e8f8e14d1207dc1838a91f0f01d0c90481bd764d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/763efdc10217e5aef3e187e24164b3cdc56b412f63e3f4564eb7cb3177b01112.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f41a6358e8640f278fdac3a5e8f8e14d1207dc1838a91f0f01d0c90481bd764d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/763efdc10217e5aef3e187e24164b3cdc56b412f63e3f4564eb7cb3177b01112.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 20,
  rating: 5,
  reviewCount: 18,
  isInsider: true,
  description:
    'HEY CHAMP makes chef crafted candy bars with the highest quality ingredients. start with classic flavors, like our pretzel shortbread with salted caramel, or get a bit more wild with our brown butter rice krispie and miso caramel. we like to keep things interesting, but approachable. each bar is hand-made, hand-cut and, of course, hand-dipped in 66% dark milk chocolate. one might even call them... grown up candy bars :)\n\nhand-made on the eastside - LA\n\nSHIPPING INFORMATION\n\nnovember > may we ship via UPS or USPS with no insulation and the lowest shipping rates we can! we check the weather prior to every shipment :):)\n\njune > october we ship 2nd day via UPS with insulation to avoid melt-age. orders will have a "shipping/handling" fee associated that is $2/case \n\nplease do not hesitate if you have any questions! \n\n',
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:47.872Z",
    importedBy: "entity-db-cli",
  },
};
